(function() {
  /**
   * Get the validity of input elements
   *
   * @param {boolean} [nonexistentElementValidity = true]
   *
   * @return boolean
   */
  $.fn.getValidity = function (nonexistentElementValidity) {
    // Set default value of param to true
    if (nonexistentElementValidity !== false) {
      nonexistentElementValidity = true;
    }

    // By default, the validity is true
    var validity = true;

    // Set validity to false if element does not exist
    if (nonexistentElementValidity === false && $(this).length === 0) {
      validity = false;
    }

    // Loop through the input elements and update validity
    this.each(function () {
      if (this.validity.valid !== true) {
        validity = false;
      }
    });

    // Return the validity
    return validity;
  };

  /**
   * Add or remove the error class to elements
   *
   * @return void
   */
  $.fn.setValidityClass = function (valid) {
    if (valid === true) {
      this.each(function () {
        $(this).removeClass('has-error');
      });
    } else {
      this.each(function () {
        $(this).addClass('has-error');
      });
    }
  };
})(this);
